module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a1q"
  }, [_c('PinchInImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPinchIn),
      expression: "showPinchIn"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner flexrow",
    class: _vm.cssLayoutID
  }, [_c('div', {
    staticClass: "toparea-play"
  }, [_c('div', {
    staticClass: "eleAni flexcenter hide"
  }, [(_vm.isSelect) ? _vm._l((_vm.answersTextList), function(answer, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showSelectAnswer),
        expression: "showSelectAnswer"
      }],
      key: index,
      staticClass: "item flexcenter hv"
    }, [_c('div', {
      staticClass: "input bg-white",
      on: {
        "click": function($event) {
          return _vm.clickAnswer(answer, index)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(answer))
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "icon-voice",
      on: {
        "click": function($event) {
          return _vm.audioPlay(_vm.answersList[index].sounds[0])
        }
      }
    })])
  }) : _vm._l((_vm.answersTextList), function(answer, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showSelectAnswer),
        expression: "showSelectAnswer"
      }],
      key: index,
      staticClass: "item flexcenter hv"
    }, [_c('div', {
      staticClass: "input bg-white",
      attrs: {
        "id": _vm.isAniTarget[index]
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(answer))
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "icon-voice",
      on: {
        "click": function($event) {
          return _vm.audioPlay(_vm.answersList[index].sounds[0])
        }
      }
    })])
  }), _vm._v(" "), (_vm.isScrollIconVisible) ? _c('div', {
    staticClass: "icon-scroll"
  }) : _vm._e()], 2)]), _vm._v(" "), (_vm.isEnvironmentPc()) ? [_c('div', {
    staticClass: "cards-container active-type2"
  }, _vm._l((_vm.templateTypes), function(templateType, index) {
    return _c('div', {
      key: index,
      staticClass: "card-inner card-voice",
      class: templateType
    }, _vm._l((_vm.actGroupIndexList[index]), function(item) {
      return _c('div', {
        key: item,
        staticClass: "item",
        class: {
          type1: _vm.isChallenge(_vm.pathstep.acts[item]) && !_vm.showText[item],
          active: _vm.isActive[item]
        },
        style: ({
          cursor: _vm.cursorTypes[item]
        })
      }, [_c('A1Qact', {
        attrs: {
          "act": _vm.pathstep.acts[item],
          "showText": _vm.showText[item],
          "showResult": _vm.showResult[item],
          "isCorrect": _vm.isCorrect,
          "isInCorrect": _vm.isInCorrect,
          "index": item,
          "isAnswerTarget": _vm.isAnswerTarget[item],
          "isAnimate": _vm.isAnimate
        },
        on: {
          "childSetTarget": _vm.childSetTarget,
          "animateEnd": _vm.animateEnd
        }
      })], 1)
    }), 0)
  }), 0)] : [_c('div', {
    staticClass: "cards-container active-type2 swiper-container swiper-container1"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.templateTypes), function(templateType, index) {
    return _c('div', {
      key: index,
      staticClass: "card-inner card-voice swiper-slide",
      class: templateType
    }, [_c('div', {
      staticClass: "swiper-container swiper-container2"
    }, [_c('div', {
      staticClass: "swiper-wrapper"
    }, _vm._l((_vm.actGroupIndexList[index]), function(item) {
      return _c('div', {
        key: item,
        staticClass: "item swiper-slide",
        class: {
          type1: _vm.isChallenge(_vm.pathstep.acts[item]) && !_vm.showText[item],
          active: _vm.isActive[item]
        },
        style: ({
          cursor: _vm.cursorTypes[item]
        })
      }, [_c('A1Qact', {
        attrs: {
          "act": _vm.pathstep.acts[item],
          "showText": _vm.showText[item],
          "showResult": _vm.showResult[item],
          "isCorrect": _vm.isCorrect,
          "isInCorrect": _vm.isInCorrect,
          "index": item,
          "isAnswerTarget": _vm.isAnswerTarget[item],
          "isAnimate": _vm.isAnimate
        },
        on: {
          "childSetTarget": _vm.childSetTarget,
          "animateEnd": _vm.animateEnd,
          "onTouchStart": _vm.onTouchStart,
          "onTouchEnd": _vm.onTouchEnd
        }
      })], 1)
    }), 0)])])
  }), 0)])]], 2)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46754bc8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-46754bc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/A1Q.vue
// module id = 622
// module chunks = 1